export default __webpack_public_path__ + "static/media/logo.cdc3a165.png";